"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initialiseComponent;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _jsxLoader = require("@insided/deprecated-libs/jsxLoader");

var _utils = require("../../pages/utils");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _AppProviders = _interopRequireDefault(require("./AppProviders"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _bootstrap = require("@insided/shared/bootstrap");

var _logger = require("@insided/shared/services/logger");

var _ComponentDebugger = _interopRequireDefault(require("./ComponentDebugger"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _initialiseComponent(_x, _x2, _x3) {
  return _initialiseComponent2.apply(this, arguments);
}

function _initialiseComponent2() {
  _initialiseComponent2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(derivedComponentNameFromFilePath, el, params) {
    var _params$phrases, _user$email, _user$avatar, _user$profileFields, _user$badges, _ref, _params$phrases2;

    var unrender,
        componentDebugger,
        child,
        _yield$jsxLoader,
        _yield$jsxLoader2,
        cssAnchorName,
        LoadedComponent,
        user,
        _el$dataset,
        pageContext,
        appElement,
        _appElement$getAttrib,
        userPermissions,
        _appElement$getAttrib2,
        userContextValue,
        translationContextValue,
        appState,
        result,
        fallbackContent,
        _args2 = arguments;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            unrender = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
            componentDebugger = new _ComponentDebugger.default(el);
            componentDebugger.markHydrationStart();
            child = el.firstChild; // preact render() also accepts text Nodes as third argument

            if (!el.firstChild) {
              child = document.createElement('div');
              el.appendChild(child);
            }

            if (!unrender) {
              _context2.next = 8;
              break;
            }

            (0, _preact.render)('', el, child);
            return _context2.abrupt("return", null);

          case 8:
            _context2.next = 10;
            return (0, _jsxLoader.jsxLoader)(derivedComponentNameFromFilePath);

          case 10:
            _yield$jsxLoader = _context2.sent;
            _yield$jsxLoader2 = (0, _slicedToArray2.default)(_yield$jsxLoader, 2);
            cssAnchorName = _yield$jsxLoader2[0];
            LoadedComponent = _yield$jsxLoader2[1];
            (0, _translations.addTranslationDict)((_params$phrases = params.phrases) !== null && _params$phrases !== void 0 ? _params$phrases : params.translations);
            params.parentEl = el;
            user = (0, _insidedDataStorage.getInsidedData)('user');

            if (user) {
              _context2.next = 22;
              break;
            }

            if (!((_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.noContext && LoadedComponent)) {
              _context2.next = 20;
              break;
            }

            return _context2.abrupt("return", (0, _preact.render)((0, _preact.h)(LoadedComponent, params), el, child));

          case 20:
            (0, _bootstrap.logError)("window.inSidedData is not ready during initialization of \"".concat(derivedComponentNameFromFilePath, "\""));
            return _context2.abrupt("return", (0, _preact.render)((0, _preact.h)("span", {
              "data-widget": derivedComponentNameFromFilePath
            }), el, child));

          case 22:
            if (LoadedComponent) {
              _context2.next = 24;
              break;
            }

            return _context2.abrupt("return", null);

          case 24:
            pageContext = _utils.page404WithoutContext;
            appElement = (0, _bootstrap.resolveScriptElement)();

            try {
              pageContext = JSON.parse((_appElement$getAttrib = appElement === null || appElement === void 0 ? void 0 : appElement.getAttribute('data-pageContext')) !== null && _appElement$getAttrib !== void 0 ? _appElement$getAttrib : '{}');
            } catch (err) {
              _logger.logger.error(err, {
                app: 'destination',
                component: derivedComponentNameFromFilePath,
                action: 'parsePageContext'
              });
            }

            userPermissions = {
              permissions: [],
              readableCategories: []
            };

            try {
              userPermissions = JSON.parse((_appElement$getAttrib2 = appElement === null || appElement === void 0 ? void 0 : appElement.getAttribute('data-userPermissions')) !== null && _appElement$getAttrib2 !== void 0 ? _appElement$getAttrib2 : '');
            } catch (err) {
              _logger.logger.error(err, {
                app: 'destination',
                component: derivedComponentNameFromFilePath,
                action: 'parseUserPermissions'
              });
            }

            if (cssAnchorName) {
              el.setAttribute('data-css-anchor', cssAnchorName);
            } else {
              _logger.logger.error(new Error("Component ".concat(derivedComponentNameFromFilePath, " does not have an \"export const cssAnchorName =\"")), {
                app: 'destination',
                component: derivedComponentNameFromFilePath,
                action: 'resolveCssAnchor'
              });
            }

            userContextValue = {
              id: user.userid ? parseInt(user.userid) : null,
              email: (_user$email = user.email) !== null && _user$email !== void 0 ? _user$email : '',
              rank: user.rank,
              rankName: user.rankName,
              rankIcon: user.rankIcon,
              name: user.name,
              role: user.role,
              mainRole: user.mainRole,
              loginSource: user.loginSource,
              registerSource: user.registerSource,
              avatar: (_user$avatar = user.avatar) !== null && _user$avatar !== void 0 ? _user$avatar : '',
              isModerator: user.isModerator,
              pmUnreadCount: user.pmUnreadCount,
              pmTotalCount: user.pmTotalCount,
              topicsCount: user.topicsCount,
              repliesCount: user.repliesCount,
              solvedCount: user.solvedCount,
              joindate: user.joindate,
              likes: user.likes,
              likes_given: user.likes_given,
              profileFields: (_user$profileFields = user.profileFields) !== null && _user$profileFields !== void 0 ? _user$profileFields : [],
              badges: (_user$badges = user.badges) !== null && _user$badges !== void 0 ? _user$badges : []
            };
            translationContextValue = {
              translations: (_ref = (_params$phrases2 = params.phrases) !== null && _params$phrases2 !== void 0 ? _params$phrases2 : params.translations) !== null && _ref !== void 0 ? _ref : {},
              language: (0, _globals.default)('communityLanguage')
            };
            appState = (0, _globals.default)('appState');
            result = (0, _preact.render)((0, _preact.h)(_AppProviders.default, {
              modules: (0, _globals.default)('activeModules') || [],
              translationContext: translationContextValue,
              userContext: userContextValue,
              pageContext: _objectSpread(_objectSpread({}, pageContext), {}, {
                fullUrl: new URL(window.location.href)
              }),
              userPermissions: userPermissions,
              appState: appState
            }, (0, _preact.h)(LoadedComponent, params)), el, child);
            fallbackContent = el.querySelector('.js-fallback-content');

            if (fallbackContent) {
              fallbackContent.style.display = 'none';
            } // Debug: Complete hydration and show panel


            componentDebugger.completeHydration();
            _context2.next = 39;
            return componentDebugger.render();

          case 39:
            if (module.hot) {
              module.hot.accept( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                var _yield$jsxLoader3, _yield$jsxLoader4, LoadedComponent;

                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _jsxLoader.jsxLoader)(derivedComponentNameFromFilePath);

                      case 2:
                        _yield$jsxLoader3 = _context.sent;
                        _yield$jsxLoader4 = (0, _slicedToArray2.default)(_yield$jsxLoader3, 2);
                        LoadedComponent = _yield$jsxLoader4[1];
                        (0, _preact.render)((0, _preact.h)(_AppProviders.default, {
                          modules: (0, _globals.default)('activeModules') || [],
                          translationContext: translationContextValue,
                          userContext: userContextValue,
                          pageContext: _objectSpread(_objectSpread({}, pageContext), {}, {
                            fullUrl: new URL(window.location.href)
                          }),
                          userPermissions: userPermissions,
                          appState: appState
                        }, (0, _preact.h)(LoadedComponent, params)), el, child);

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            }

            return _context2.abrupt("return", result);

          case 41:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initialiseComponent2.apply(this, arguments);
}

function initialiseComponent(_x4, _x5, _x6) {
  return _initialiseComponent3.apply(this, arguments);
}

function _initialiseComponent3() {
  _initialiseComponent3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(derivedComponentNameFromFilePath, el, params) {
    var unrender,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            unrender = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
            _context3.prev = 1;
            _context3.next = 4;
            return _initialiseComponent(derivedComponentNameFromFilePath, el, params, unrender);

          case 4:
            return _context3.abrupt("return", _context3.sent);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](1);

            _logger.logger.error(_context3.t0, {
              app: 'destination',
              component: derivedComponentNameFromFilePath,
              phase: 'destination-init'
            });

            return _context3.abrupt("return", null);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 7]]);
  }));
  return _initialiseComponent3.apply(this, arguments);
}